import { AGENT_PHASES, type AgentPhase } from '../../constants';
import { theme } from '../../styles/theme';
import { CircleCheck, Compass } from 'lucide-react';

interface SurveyActionsProps {
  phase: AgentPhase;
  hasItinerary: boolean;
  onRetry: () => void;
  onReset: () => void;
  onAcceptItinerary?: () => void;
}

export function SurveyActions({ phase, hasItinerary, onRetry, onReset, onAcceptItinerary }: SurveyActionsProps) {
  if (phase !== AGENT_PHASES.COMPLETE) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.lg, padding: `${theme.spacing.lg} ${theme.spacing['2xl']}`, borderTop: `1px solid ${theme.colors.borderLight}`, alignItems: 'center' }}>
      <div style={{ display: 'flex', gap: theme.spacing.md, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button className="btn-secondary" onClick={onReset}>
          <Compass size={16} /> Plan a New Journey
        </button>
        {hasItinerary && onAcceptItinerary && (
          <button
            className="btn-primary"
            onClick={onAcceptItinerary}
            style={{
              padding: `${theme.spacing.md} ${theme.spacing.xl}`,
              fontSize: '10px',
              textTransform: 'uppercase' as const,
              letterSpacing: '0.15em',
            }}
          >
            <CircleCheck size={16} /> Accept Itinerary
          </button>
        )}
      </div>
    </div>
  );
}
